module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-choice-summary"
  }, [_c('div', _vm._l((_vm.product.stockAttributes), function(attr) {
    return _c('span', {
      staticClass: "specific text-muted",
      class: ("-" + (attr.key))
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(attr.key) + ": "), _c('span', {
      staticClass: "selected"
    }, [_vm._v(_vm._s(_vm.choices[attr.key] || '-'))])])])
  }), 0), _vm._v(" "), (_vm.lowQuantity) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "mt-15 text-muted",
    class: {
      '-error --error': !_vm.stockAvailable
    }
  }, [_vm._v("\n      จำนวนคงเหลือ:\n      "), (!_vm.stockChecking) ? _c('em', [(_vm.stockQuantity > 0) ? _c('span', [_vm._v("ประมาณ ")]) : _vm._e(), _vm._v(_vm._s(_vm._f("comma")(_vm.stockQuantity)) + " รายการ")]) : _c('em', [_vm._v("กำลังตรวจสอบ...")]), _vm._v(" "), (_vm.stockAvailable) ? _c('div', {
    staticClass: "fl-right"
  }, [_vm._v("✔")]) : _c('div', {
    staticClass: "fl-right"
  }, [_vm._v("✗")]), _vm._v(" "), _c('br'), _c('button', {
    staticClass: "text-muted-ss",
    attrs: {
      "disabled": _vm.stockChecking
    },
    on: {
      "click": function($event) {
        return _vm.checkStock()
      }
    }
  }, [_vm._v("ตรวจสอบอีกครั้ง")])])]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f3a461c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3a461c2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductChoiceSummary.vue
// module id = 765
// module chunks = 1